<template>
    <div id="badge_details" class="seller-badge-modal">
        <Modal
            class="badge-details-frontend-site"
            :title="''"
            :header="true"
            :footer="false"
            :width="'35%'"
            v-if="badges.length > 0"
            @close="hideModal">
            <template slot="header">
                <div class="modal-title">
                    <h2>{{ __('Congratulations!', 'dokan') }}</h2>
                    <p>
                        {{ __('You have unlocked ', 'dokan') }}
                        <span class="color-blue">{{ sprintf( _n( '%d New Badge', '%d New Badges', badges.length, 'dokan' ), badges.length )}}</span>
                    </p>
                </div>
            </template>
            <template slot="body">
                <div class="modal-sub-title">
                    <h3>{{ __('Acquired Badge & Level:', 'dokan') }}</h3>
                </div>
                <template v-for="(badge, badge_id) in badges" >
                    <div class="modal-level-box" :title="badge.badge_name" :key="badge_id">
                        <div class="level_description">
                            <div class="left-content">
                                <div class="modal-img container">
                                    <img :src="badge.badge_logo" :alt="badge.badge_name">
                                </div>
                            </div>
                            <div class="right-content">
                                <p>
                                    {{badge.badge_name}}
                                </p>
                                <template v-if="!loading">
                                    <p v-for="(level) in badge.levels" class="level_acquisition" v-html="getBadgeLevelConditionText(badge.event, level, verificationTypes)"></p>
                                </template>
                            </div>
                        </div>
                    </div>
                </template>
            </template>
        </Modal>
    </div>
</template>

<script>

import Modal from "../../components/Modal.vue";
import mixin from "../../Mixin.js";

export default {
    name: 'UnseenBadges',

    mixins: [mixin],

    components: {
        Modal,
    },

    inject: ['getUnseenBadges', 'setBadgeAsSeen',],

    data() {
        return {
            loading: true,
            badges: this.getUnseenBadges,
            verificationTypes: {},
        };
    },

    created() {
    },

    mounted() {
        this.fetchVerificationTypes()
    },

    watch: {

    },

    methods: {
        isVendorAcquiredLevel( level, badge ) {
            if ( undefined === badge.acquired ) {
                return false;
            }
            if ( badge.acquired[level.id] ) {
                return true;
            }
            return false;
        },

        hideModal() {
            this.badges = [];
            this.setBadgeAsSeen();
        },
        fetchVerificationTypes() {
            // const self = this;
            this.loading = true;
            dokan.api
                .get( '/seller-badge/verification-types/' )
                .then( ( response ) => {
                    this.verificationTypes = response;
                    this.loading = false;
                } )
                .fail( ( jqXHR ) => {
                    const message = dokan_handle_ajax_error( jqXHR );
                    if ( message ) {
                        this.showErrorAlert( message );
                    }
                    this.loading = false;
                } );
        },
    }
}
</script>

<style lang="less" scoped>
.badge-details-frontend-site {
    .modal-title {
        text-align: center;
        width: 100%;

        h2,
        p {
            color: #000 !important;
            font-size: 1.125rem !important;
            font-weight: 600;
        }
    }

    .right-content {
        .level_acquisition {
            font-weight: 400 !important;
        }
    }
}
</style>
